export const QA_NAME_VIEWING_PROFILE_PAGE = 'rentalPortalViewingProfile'

export const QA_NAME_VIEWING_PROFILE_NOTE = 'viewingProfileNote'

export const QA_NAME_VIEWING_PROFILE_RETRY = 'viewingProfileRetry'

export const QA_NAME_VIEWING_PROFILE_PREVIEW_OPEN_FULL_PAGE =
  'viewingPreviewOpenFullPage'

export const QA_NAME_VIEWING_PROFILE_WIDGET_CREATED = 'viewingProfileCreated'

export const QA_NAME_VIEWING_PROFILE_WIDGET_LISTING = 'viewingProfileListing'

export const VIEWING_PROFILE_ACTION = {
  addNote: 'add-note',
  addToCalendar: 'add-to-calendar',
  archive: 'archive',
  cancel: 'cancel',
  completed: 'completed',
  noShow: 'no-show',
  reschedule: 'reschedule',
  restore: 'restore',
  uploadDocument: 'upload-document',
}

export const QA_NAME_VIEWING_PROFILE_STATUS_SELECT = 'viewingProfileStatus'

export const QA_NAME_VIEWING_PROFILE_ACTION = {
  [VIEWING_PROFILE_ACTION.addNote]: 'viewingProfileAddNote',
  [VIEWING_PROFILE_ACTION.addToCalendar]: 'viewingProfileAddToCalendar',
  [VIEWING_PROFILE_ACTION.archive]: 'viewingProfileArchive',
  [VIEWING_PROFILE_ACTION.cancel]: 'viewingProfileCancel',
  [VIEWING_PROFILE_ACTION.completed]: 'viewingProfileCompleted',
  [VIEWING_PROFILE_ACTION.noShow]: 'viewingProfileNoShow',
  [VIEWING_PROFILE_ACTION.reschedule]: 'viewingProfileReschedule',
  [VIEWING_PROFILE_ACTION.restore]: 'viewingProfileRestore',
  [VIEWING_PROFILE_ACTION.uploadDocument]: 'viewingProfileUploadDocument',
}
